var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import "../components/card.component.js";
import { Event } from "../models/enums.js";
import { DataStore } from "../services/datastore.service.js";
import { EventBus } from "../services/eventbus.service.js";
let AppCards = class AppCards extends LitElement {
    constructor() {
        super();
        this.loading = false;
        this.loadingModal = false;
        this.allowedDrafts = 10;
        this.allowedActive = 10;
        this._select = "";
        this.cards = [];
        this.selectedEdit = false;
        this.wakeupEvent = () => {
            if (this._select !== "") {
                this.fetchCards();
            }
        };
        this.refreshEvent = () => {
            this.fetchCards();
        };
        this.requestUpdateEvent = () => {
            this.requestUpdate();
        };
        this.escapeEvent = () => {
            this.closeModalSave();
            this.closeModalNext();
        };
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
    }
    connectedCallback() {
        super.connectedCallback();
        this.eventbus.addEventListener(Event.Escape, this.escapeEvent);
        this.eventbus.addEventListener(Event.Refresh, this.refreshEvent);
        this.eventbus.addEventListener(Event.RequestUpdate, this.requestUpdateEvent);
        this.eventbus.addEventListener(Event.Wakeup, this.wakeupEvent);
    }
    disconnectedCallback() {
        this.eventbus.removeEventListener(Event.Escape, this.escapeEvent);
        this.eventbus.removeEventListener(Event.Refresh, this.refreshEvent);
        this.eventbus.removeEventListener(Event.RequestUpdate, this.requestUpdateEvent);
        this.eventbus.removeEventListener(Event.Wakeup, this.wakeupEvent);
        super.disconnectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has('location') && this.location?.params?.select) {
            this.datastore.verifyPageAccess(window.location.pathname);
            this._select = this.location.params.select;
            if (this.datastore.token) {
                this.fetchCards();
            }
        }
        super.updated(changedProperties);
    }
    createRenderRoot() {
        return this;
    }
    async fetchCards() {
        this.loading = true;
        await this.datastore
            .fetchCardlist(this._select)
            .then((response) => {
            this.cards = response;
        })
            .catch((error) => {
            this.eventbus.dispatchError(error);
        })
            .finally(() => (this.loading = false));
    }
    addCard() {
        const drafts = this.cards.filter((card) => card.status === 'draft');
        if (drafts.length + 1 > this.allowedDrafts) {
            this.eventbus.dispatchEvent(Event.Toast, {
                text: `Only ${this.allowedDrafts} drafts allowed`,
                classes: "fas fa-hand",
                type: "is-warning",
            });
        }
        else {
            this.openModalSave(this.datastore.createEmptyCard());
        }
    }
    openModalSave(card) {
        this.selectedCard = JSON.parse(JSON.stringify(card));
        this.selectedEdit = true;
        document.getElementById("modalsave").classList.add("is-active");
        document.getElementById("modalsave")?.scrollTo(0, 0);
        this.requestUpdate();
    }
    saveCard() {
        if (this.selectedCard.id) {
            this.datastore
                .updateCard(this.selectedCard)
                .then(() => {
                this.selectedCard = {};
                this.selectedEdit = false;
                this.closeModalSave();
                this.fetchCards();
            })
                .catch((error) => {
                this.eventbus.dispatchError(error);
            });
        }
        else {
            this.datastore
                .createCard(this.selectedCard)
                .then(async (_) => {
                this.selectedCard = {};
                this.closeModalSave();
                this.fetchCards();
            })
                .catch((error) => {
                this.eventbus.dispatchError(error);
            });
        }
    }
    closeModalSave() {
        this.selectedCard = undefined;
        this.selectedEdit = false;
        document.getElementById("modalsave").classList.remove("is-active");
        this.requestUpdate();
    }
    openModalNext(card) {
        if (card.status === "draft") {
            const active = this.cards.filter((card) => card.status === 'active');
            if (active.length + 1 > this.allowedActive) {
                this.eventbus.dispatchEvent(Event.Toast, {
                    text: `Only ${this.allowedActive} active cards allowed`,
                    classes: "fas fa-hand",
                    type: "is-warning",
                });
                return;
            }
        }
        this.selectedCard = JSON.parse(JSON.stringify(card));
        document.getElementById("modalnext").classList.add("is-active");
        this.requestUpdate();
    }
    updateCardStatus() {
        this.loadingModal = true;
        const updatedCard = JSON.parse(JSON.stringify(this.selectedCard));
        updatedCard.status = this.selectedCard.status === "draft" ? "active" : "archived";
        this.datastore
            .updateStatus(updatedCard)
            .then(async () => {
            this.selectedCard = undefined;
            this.closeModalNext();
            await this.fetchCards().then(() => {
                this.loadingModal = false;
                this.eventbus.dispatchEvent(Event.Toast, {
                    text: `Card '${updatedCard.title}' is now ${updatedCard.status}`,
                    classes: `fas ${updatedCard.status === 'active' ? 'fa-check' : 'fa-archive'}`,
                    type: "is-info",
                });
            });
        })
            .catch((error) => {
            this.loadingModal = false;
            this.closeModalNext();
            this.eventbus.dispatchError(error);
        });
    }
    closeModalNext() {
        this.selectedCard = undefined;
        document.getElementById("modalnext").classList.remove("is-active");
        this.requestUpdate();
    }
    recipientArchive(card) {
        this.datastore
            .archiveReceivedCard(card)
            .then(async () => {
            await this.fetchCards();
        })
            .catch((error) => {
            this.eventbus.dispatchError(error);
        });
    }
    render() {
        return html `
            ${this.loading === true ? html `
                <div class="columns is-centered">
                    <div class="column has-text-centered mt-4">
                        <span class="icon has-text-info fa-2x">
                            <i class="fas fa-spin fa-spinner"></i>
                        </span>
                    </div>
                </div>
            ` : html `
                ${this.cards.length === 0 ? this.zeroCards() : ""}
                <div class="fade-in columns is-multiline is-centered">
                    ${this.cards.map((card) => html `
                        <div class="column is-half">
                            ${this._select === "current" ? html `
                                ${card.clips.length === card.size ? html `
                                    <div class="ctc-actions-wrapper">
                                        ${this.datastore.user?.id === card.creator ? html `
                                            <div class="ctc-actions-owner has-text-right">
                                                <span @click="${() => this.openModalNext(card)}" class="icon is-clickable">
                                                    <i class="fas fa-archive"></i>
                                                </span>
                                            </div>
                                        ` : html `
                                            <div class="ctc-actions has-text-right">
                                                <span @click="${() => this.recipientArchive(card)}" class="icon is-clickable">
                                                    <i class="fas fa-archive"></i>
                                                </span>
                                            </div>
                                        `}
                                    </div>
                                ` : ""}
                                ${this.datastore.user?.id === card.creator ? html `
                                    <app-card .card=${card} .owner=${true} .displaylink=${true} .displayto=${true}></app-card>
                                ` : html `
                                    <app-card .card=${card} .displayfrom=${true} .displayclip=${true}></app-card>
                                `}
                            ` : ""}
                            ${this._select === "draft" || this._select === "out" ? html `
                                <div class="ctc-actions-wrapper">
                                    <div class="ctc-actions-owner has-text-right">
                                        <span @click="${() => this.openModalNext(card)}" class="icon is-clickable">
                                            <i class="fas fa-${card.status === "draft" ? "paper-plane" : "archive"}"></i>
                                        </span>
                                    </div>
                                </div>
                                ${card.status === "draft" ? html `
                                    <a @click="${() => this.openModalSave(card)}">
                                        <app-card .card=${card} .owner=${true} .displayto=${true}></app-card>
                                    </a>
                                ` : html `
                                    <app-card .card=${card} .owner=${true} .displayto=${true} .displaylink=${true}></app-card>
                                `}
                            ` : ""}
                            ${this._select === "in" ? html `
                                ${card.clips.length === card.size ? html `
                                    <div class="ctc-actions-wrapper">
                                        <div class="ctc-actions has-text-right">
                                            <span @click="${() => this.recipientArchive(card)}" class="icon is-clickable">
                                                <i class="fas fa-${card.status === "draft" ? "paper-plane" : "archive"}"></i>
                                            </span>
                                        </div>
                                    </div>
                                ` : ""}
                                <app-card .card=${card} .displayfrom=${true} .displayclip=${true}></app-card>
                            ` : ""}
                            ${this._select === "archive" ? html `
                                <app-card .card=${card} .owner=${this.datastore.user?.id === card.creator} .displayfrom=${true} .displayto=${true}></app-card>
                            ` : ""}
                        </div>
                    `)}
                </div>
            `}
            ${this._select === "draft" ? html `
                <div class="buttons is-centered">
                    <button class="button shadow is-link is-rounded has-background-primary" style="position:fixed;bottom:15px;margin:0px;" @click="${() => this.addCard()}">
                        <span class="icon"><i class="fas fa-plus"></i></span>
                    </button>
                </div>
            ` : ""}

            <div id="modalsave" class="modal">
                <div class="modal-background"></div>
                    <div class="modal-card">
                        ${this.selectedCard ? html `
                            <app-card id="modal-card-body" .card=${this.selectedCard} .edit="${this.selectedEdit}" .displayfrom="${this._select === "in" ? true : false}" .displayclip="${this._select === "in" ? true : false}"></app-card>
                        ` : ""}
                        <div class="container is-fluid mt-4 mb-6 has-text-centered">
                            <button id="closeButton" class="button is-warning ${this.selectedCard?.status === "draft" ? "is-pulled-right" : ""}" @click="${this.closeModalSave}">
                                <span class="icon">
                                    <i class="fas fa-times"></i>
                                </span>
                                <span>Close</span>
                            </button>
                        ${this.selectedCard?.status === "draft" ? html `
                            <button class="button is-success is-pulled-left" @click="${this.saveCard}">
                                <span class="icon"><i class="fas ${this.loading ? "fa-circle-notch fa-spin" : "fa-check"}"></i></span>
                                <span>Save</span>
                            </button>
                        ` : ""}
                    </div>
                </div>
            </div>

            <div id="modalnext" class="modal">
                <div class="modal-background"></div>
                <div class="modal-card">
                    <header class="modal-card-head has-background-primary">
                        <p class="modal-card-title has-text-white">${this.selectedCard?.status === "draft" ? "Activate" : "Archive"} '${this.selectedCard?.title}' ?</p>
                    </header>
                    <section class="modal-card-body has-text-black">
                        ${this.selectedCard?.status === "draft"
            ? "It is not possible to update the card after activation. If you supplied a valid email we will notify the recipient."
            : "If card is archived it is no longer in active state. Anonymous card will no longer be available from link, registered user card will be archived."}
                    </section>
                    <footer class="modal-card-foot">
                        <div class="container is-fluid has-text-centered">
                            <button @click="${() => this.updateCardStatus()}" class="button is-success is-pulled-left">
                                <span class="icon">
                                    ${this.loadingModal ? html `
                                        <i class="fas fa-circle-notch fa-spin"></i>
                                    ` : html `
                                        <i class="fas ${this.selectedCard?.status === "draft" ? "fa-play" : "fa-archive"}"></i>
                                    `}
                                </span>
                                <span>${this.selectedCard?.status === "draft" ? "Activate" : "Archive"}</span>
                            </button>
                            <button @click="${() => this.closeModalNext()}" class="button is-warning is-pulled-right">
                                <span class="icon">
                                    <i class="fas fa-times"></i>
                                </span>
                                <span>Close</span>
                            </button>
                        </div>
                    </footer>
                </div>
            </div>
        `;
    }
    zeroCards() {
        switch (this._select) {
            case "current":
                return html `
                    <div class="columns is-mobile is-centered">
                        <div class="mt-4 column is-half notification is-success is-light has-text-centered shadow">You have no cards in your inbox or outbox.</div>
                    </div>
                `;
            case "draft":
                return html `
                    <div class="columns is-mobile is-centered">
                        <div class="mt-4 column is-half notification is-success is-light has-text-centered shadow">Press the + button below to add a draft.</div>
                    </div>
                `;
            case "out":
                return html `
                    <div class="columns is-mobile is-centered">
                        <div class="mt-4 column is-half notification is-success is-light has-text-centered shadow">You have no cards in your outbox.</div>
                    </div>
                `;
            case "in":
                return html `
                    <div class="columns is-mobile is-centered">
                        <div class="mt-4 column is-half notification is-success is-light has-text-centered shadow">You have no cards in your inbox.</div>
                    </div>
                `;
            case "archive":
                return html `
                    <div class="columns is-mobile is-centered">
                        <div class="mt-4 column is-half notification is-success is-light has-text-centered shadow">You have no cards in your archive.</div>
                    </div>
                `;
            default:
                return html `
                    <div class="columns is-mobile is-centered">
                        <div class="mt-4 column is-half notification is-success is-light has-text-centered shadow">You have no cards.</div>
                    </div>
                `;
        }
    }
};
__decorate([
    property()
], AppCards.prototype, "location", void 0);
__decorate([
    state()
], AppCards.prototype, "loading", void 0);
__decorate([
    state()
], AppCards.prototype, "loadingModal", void 0);
AppCards = __decorate([
    customElement("app-cards")
], AppCards);
export { AppCards };
//# sourceMappingURL=user_cards.js.map